import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../stores/application.store";
import Header from './Header/Header';
import Footer from './Footer/Footer';
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import Home from './Home/Home';
import { LandscapeAlert } from "./Landscape/LandscapeAlert";
import Article from './Article/Article';

function App() {
  let { scroll, setScroll } = useContext(AppContext);

  return (
    <>
      <Router>
        {/* <Switch> */}
        <LandscapeAlert />
        <Header />
        <Route exact path="/" render={() => {
          return <Home />;
        }} />
        <Route exact strict path="/:id" render={({ match }) => {
          if (/^[0-9]{7}$/.test(match.params.id))
            return <Article match={match} />;
          else
            return <Home />;
        }} />
        {/* <Footer /> */}
        {/* </Switch> */}
      </Router>
    </>
  );
}

export default App;
